var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipsisY(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 10.8337C10.4606 10.8337 10.8337 10.4606 10.8337 10.0003C10.8337 9.54009 10.4606 9.16699 10.0003 9.16699C9.54009 9.16699 9.16699 9.54009 9.16699 10.0003C9.16699 10.4606 9.54009 10.8337 10.0003 10.8337Z",
    stroke: "#282D38",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 10.8337C16.2936 10.8337 16.6667 10.4606 16.6667 10.0003C16.6667 9.54009 16.2936 9.16699 15.8333 9.16699C15.3731 9.16699 15 9.54009 15 10.0003C15 10.4606 15.3731 10.8337 15.8333 10.8337Z",
    stroke: "#282D38",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16634 10.8337C4.62658 10.8337 4.99967 10.4606 4.99967 10.0003C4.99967 9.54009 4.62658 9.16699 4.16634 9.16699C3.7061 9.16699 3.33301 9.54009 3.33301 10.0003C3.33301 10.4606 3.7061 10.8337 4.16634 10.8337Z",
    stroke: "#282D38",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipsisY);
export default __webpack_public_path__ + "static/media/ellipsis_y.8bee8b66e750d7ba4c0a23fd51d30845.svg";
export { ForwardRef as ReactComponent };